import { Component, OnInit } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { HTTPService, HelperService, DataService } from 'app/services';
import { pricingTypeConstant } from 'app/constants/pricings.constatnt';

import { Subscription } from 'rxjs';

@Component({
  selector: 'app-item-dialog',
  templateUrl: './item-dialog.component.html',
  styleUrls: ['./item-dialog.component.scss'],
  providers: [DialogService],
})
export class ItemDialogComponent implements OnInit {
  type: string = '';
  itemId: string = '';
  poDetails: any = {};
  isOpenFromRO: boolean = false;
  isOpenFromPO: boolean = false;
  isEditMode: boolean = false;
  isLoading: boolean = true;
  isPartsTechItem: boolean = false;
  isLocal: boolean = false;
  isInventoryEnabled: boolean = false;
  isMarkAsInventoryEnabled: boolean = false;
  isPartWarrantiesEnabled: boolean = false;
  isQboConnected: boolean = false;
  data: any = {};
  qboItemRefs: any[] = [];
  rimTypes: any[] = [{ name: 'Alloy' }, { name: 'Steel' }, { name: 'None' }];
  categories: any[] = [];
  suppliers: any[] = [];
  pricings: any[] = [];
  pricingRules: any[] = [];
  brands: any[] = [];
  serviceFeeItemIds: any[] = [];
  defaultTitle: string = '';
  serviceItem: any;
  orderServiceId: string = '';
  orderServiceItemIndex: number = -1;
  item: any = {};
  stock: any = {};
  motorLaborPricing: any = {};
  dataServiceSubscription: Subscription;
  locations: any[] = [];
  averageCost: number = 0;
  latestPoCost: number = 0;
  isItemTaxable: boolean = false;
  defaultTaxable: boolean = false;
  isAutoLeapItem: boolean = true;
  vehicleAge: number | string = '';
  motorMarkup: number | string = '';
  isDisabled: boolean = false;
  orderId: string = '';
  estimate: any = {};
  isFeeAssociationEnabled: boolean = false;
  isCommissionPlanEnabled: boolean = false;
  isEnhancedTSEnabled: boolean = false;
  isCommissionLabor: boolean = false;
  isCommissionParts: boolean = false;
  isCommissionTire: boolean = false;
  isCommissionTireStorage: boolean = false;
  isCommissionFees: boolean = false;
  isDiscountItemEnabled: boolean = false;
  isAdHocCommissionable: boolean = false;
  isPassThroughTaxEnable: boolean = false;
  isQuickServiceEnabled: boolean = false;
  titleForCreate: any;
  // For Discount item type only
  discountOn: string = '';
  openFrom: string = '';
  onlineItem: any = {};
  isPreFilledPartFields: boolean = false;
  isGlobalCategoryEnabled: boolean = false;
  categoryType: string = '';
  isOnlineInvOrderEnabled: boolean = false;
  otherInfo: any = {};
  isPricingMatricesManagement: boolean = false;
  isPricingManagementEnable: boolean = false;
  isAttributeBasedPricingEnable: boolean = false;
  isNewItemCategoriesEnable: boolean = false;
  isSalesCodeEnabled: boolean = false;
  isChangeInPriceMatrix: boolean = false;
  isOpenFromST: boolean = false;
  cardGroupIndex: number = -1;
  isQTQAddOnEnable: boolean = false;
  isTireConnectConnected: boolean = false;
  canEditClassifications: boolean = false;
  partsLookupDropDownList: any;
  isNewPartModalEnabled: boolean = this.dataService.isNewPartModalEnabled;
  isNewTireModalEnabled: boolean = this.dataService.isNewTireModalEnabled;
  addedFromLookupDialog: boolean = false;
  isForceLocationUpdate: boolean = false;
  openNewTireStorageModal: boolean = false;

  constructor(
    private dialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private httpService: HTTPService,
    private helperService: HelperService,
    private dataService: DataService
  ) { }

  ngOnInit() {

    const { type, isFromOrder, data = {}, vehicleYear, isDisabled, estimate, onlineItem = {} } = this.dialogConfig.data;
    this.onlineItem = this.helperService.deepCopy(onlineItem);

    if(data?.isForceLocationUpdate) {
      this.isForceLocationUpdate = true;
    }
    if(type === 'tire' && this.dataService.isTireConnectEnabled) {
      this.getTireconnectIntegrationSettings();
    }

    if(type === 'tireStorage' && data.isTireStorage2Enabled) this.openNewTireStorageModal = true;

    if (data && data.serviceId) {
      this.discountOn = data.serviceId === 'order-discount' ? 'order' : 'service';
    }

    if(data && data?.isOpenFromST) {
      this.isOpenFromST = data.isOpenFromST;
      this.cardGroupIndex = data?.cardGroupIndex;
    }

    if (data && data.isFromRepairLink) {
      this.discountOn = 'service';
    }

    this.openFrom = data && data.openFrom;
    this.otherInfo = data?.otherInfo || {};

    if (!this.openFrom) {
      if (isFromOrder) {
        this.openFrom = 'RO';
      } else if (data?.isOpenFromPO) {
        this.openFrom = 'PO';
        this.poDetails = data;
      } else if (data?.openFrom === 'cannedService') {
        this.openFrom = 'cannedService';
      } else if (data?.isOpenFromInventoryAdd) {
        this.openFrom = 'inventoryAdd';
      } else if (data?.openFrom === 'parts-ordering') {
        this.openFrom = 'parts-ordering';
      } else {
        this.openFrom = 'catalog';
      }
    }

    if (this.onlineItem && Object.keys(this.onlineItem || {}).length) {
      delete this.onlineItem.preFilledPartFields;
      data.serviceItem = this.onlineItem;
    }

    this.estimate = estimate;
    this.orderId = data && data.orderId;
    this.isDisabled = isDisabled;
    this.type = type;
    this.isOpenFromRO = isFromOrder;
    this.data = data;
    this.isQboConnected = !!this.helperService.getCompany().qboId;
    this.setDataService();

    if (data && (data.type === 'part' || data.type === 'labor' || data.type === 'hazmatFee')) {
      this.titleForCreate = data.title;
    }

    if (data && (data.type === 'part' || data.type === 'labor' || data.type === 'tire')) {
      this.isChangeInPriceMatrix = data.serviceItem.isChangeInPriceMatrix
    }

    if (vehicleYear) {
      this.vehicleAge = new Date().getFullYear() - vehicleYear;
    }

    if (data && !data.serviceId && typeof data === 'string') {
      this.itemId = data;
      if(type === 'tireStorage' && this.dataService.isTireStorage2Enabled) this.openNewTireStorageModal = true;
    } else if (data) {
      this.defaultTitle = data.title;
      this.orderServiceId = data.serviceId;
      this.serviceItem = this.helperService.deepCopy(data.serviceItem);
      if (this.openFrom === 'RO' && data.serviceItem?.addedFromLookupDialog) {
        // maintain flag added item dialog
        this.addedFromLookupDialog = true;
      }
      if (data.serviceItem && (data.serviceItem.itemId === 'no-id' || (data.serviceItem.itemId === data.serviceItem._id && !data.serviceItem?.addedFromLookupDialog))) {
        if (data.serviceItem.lineCartId) {
          this.isPartsTechItem = true;
        }
        this.isAutoLeapItem = false;
        this.isLocal = true;
        this.orderServiceItemIndex = data.index;
      } else if (data.itemId) {
        this.itemId = data.itemId;
        this.orderServiceItemIndex = data.index;
        this.isLocal = false;
      }
    }

    if (data) {
      if (data.isOpenFromPO) {
        this.isOpenFromPO = true;
      }

      if (data.itemId && data.itemId !== 'no-id') {
        this.itemId = data.itemId;
        this.isEditMode = true;
      }
    }

    this.estimate?.services?.forEach(service => {
        if (service?._id === data?.serviceId) {
            service.items.forEach(item => {
                if (item.type === 'hazmatFee'
                    && item?.associatedItemsInternalReferences?.includes(this.serviceItem.itemInternalReference)
                    && item?.itemId) {
                    this.serviceFeeItemIds.push(item.itemId);
                }
            });
        }
    });

    this.initializeItem();
    if (this.isPreFilledPartFields) {
      if (this.serviceItem && typeof this.serviceItem !== 'string') {
        this.serviceItem._id = '';
        this.serviceItem.focusSupplier = true;
      }
    }
  }

  getTireconnectIntegrationSettings() {
    this.httpService.isTireConnectConnected({ populateItemAndPricing: false, populateTireConnectRefs: false })
    .then((res: any) => {
      const { isTireConnectConnected } = res;
      this.isTireConnectConnected = isTireConnectConnected;
    }, (err) => {
      this.helperService.showToaster('error', err);
    });
  }

  initializeItem() {
    this.isLoading = true;
    this.httpService.initItemData(this.type, this.itemId).then(
      async (res: any) => {
        if (res) {
          if (res.shop) {
            if (this.isOpenFromPO) {
              const taxation = {
                part: res.shop?.appsettings?.manualOrderSettings?.isTaxablePart,
                tire: res.shop?.appsettings?.manualOrderSettings?.isTaxableTire,
              };

              if ([true, false].includes(taxation[this.type])) {
                this.isItemTaxable = taxation[this.type];
              }
            } else {
              if (this.type === 'part') {
                this.isItemTaxable = res.shop.parts;
              } else {
                this.isItemTaxable = res.shop[this.type];
              }
            }

            this.defaultTaxable = this.isItemTaxable;
          }

          this.qboItemRefs = res.qboItem;
          this.suppliers = res.supplier;
          this.pricings = [];
          res.isChangeInPriceMatrix = this.isChangeInPriceMatrix;
          this.item = res.item;
          if (this.isOpenFromRO) {
            if (this.item && this.item.associatedItems && this.serviceFeeItemIds.length) {
                this.item.associatedItems = await this.httpService.getItemByIds({ itemIds: this.serviceFeeItemIds }).then(
                    (res: any) => {
                        return res;
                    },
                    (err: any) => {
                        return [];
                    }
                );
            }

            if (this.serviceItem && this.serviceFeeItemIds.length) {
                this.serviceItem['associatedItems'] = await this.httpService.getItemByIds({ itemIds: this.serviceFeeItemIds }).then(
                    (res: any) => {
                        return res;
                    },
                    (err: any) => {
                        return [];
                    }
                );
            }
          }
          this.stock = res.stock;
          if(this.item && this.dataService.isMultiLocationEnabled && this.item.shopDetails && this.item.shopDetails?.length) {
            const stockData = this.item.shopDetails.find((stockDetail) => stockDetail?.shopId === this.dataService.currentShopId);
            if ((stockData?.maxQuantity || stockData?.maxQuantity === 0) && (stockData?.restockLevel || stockData?.restockLevel === 0)) {
                this.item.maxQuantity = stockData.maxQuantity;
                this.item.restockLevel = stockData.restockLevel;
            }
          }

          // set flat rate for RO
          if(this.openFrom === 'RO' && this.data?.serviceItem?.flatRate) {
            this.item.flatRate = this.data?.serviceItem?.flatRate;
          }
          //  maintain flag
          if(this.item) {
            this.item.addedFromLookupDialog = this.addedFromLookupDialog || false;
          }
          if (res.pricings && res.pricings.length) {
            res.pricings.forEach((pricing: any) => {
              if (pricing.type === pricingTypeConstant.motorTimeMarkup) {
                this.motorLaborPricing = pricing;
              } else {
                this.pricings.push(pricing);
              }
            });
          }
          this.pricingRules = res.pricingRules;
          if (this.motorLaborPricing && this.motorLaborPricing._id) {
            for (let i = 0; i < this.motorLaborPricing.items.length; i++) {
              const { min, max, markup } = this.motorLaborPricing.items[i];

              if (this.vehicleAge >= min && this.vehicleAge <= max) {
                this.motorMarkup = markup;
              }
            }
          }

          if (this.stock) {
            this.averageCost = this.stock.averageCost;
            this.latestPoCost = this.stock.latestPoCost;
          }

          if (res.locations && res.locations.length) {
            this.locations = res.locations.map(({ _id, title, warehouseId }) => ({
              locationId: _id,
              name: title,
              warehouseId: warehouseId || null,
            }));
          }

          if (res.tags && res.tags.length) {
            for (let i = 0; i < res.tags.length; i++) {
              res.tags[i].categoryId = res.tags[i]._id;
              const tag = res.tags[i];

              if (tag.type === 'part') {
                this.categories.push(tag);
              } else if (tag.type === 'brand') {
                this.brands.push(tag);
              } else if (tag.type === 'item' && res.appsettings && res.appsettings.isGlobalCategoryEnabled) {
                this.categories.push(tag);
              }
            }
          }

          if (res.appsettings && res.appsettings.isGlobalCategoryEnabled) {
            this.categoryType = 'item';
          } else {
            this.categoryType = '';
          }
        }
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
        this.helperService.showToaster('error', err);
      }
    );
  }

  setDataService() {
    this.dataServiceSubscription = this.dataService.getData().subscribe(({ data }) => {
      if (data) {
        if (data.key === 'company-appdata-updated') {
          this.setFeatureFlag();
          this.dataServiceSubscription.unsubscribe();
        }
      }
    });

    this.setFeatureFlag();
  }

  setFeatureFlag() {
    this.isNewItemCategoriesEnable = this.dataService.isNewItemCategoriesEnable;
    this.isAttributeBasedPricingEnable = this.dataService.isAttributeBasedPricingEnable;
    this.isSalesCodeEnabled = this.dataService.isSalesCodeEnabled;
    this.isPricingManagementEnable = this.dataService.isPricingManagementEnable;
    this.isPricingMatricesManagement = this.dataService.isPricingMatricesManagement;
    this.isInventoryEnabled = this.dataService.isInventoryEnabled;
    this.isFeeAssociationEnabled = this.dataService.isFeeAssociationEnabled;
    this.isCommissionPlanEnabled = this.dataService.isCommissionPlanEnabled;
    this.isCommissionLabor = this.dataService.isCommissionLabor;
    this.isCommissionParts = this.dataService.isCommissionParts;
    this.isCommissionTire = this.dataService.isCommissionTire;
    this.isCommissionTireStorage = this.dataService.isCommissionTireStorage;
    this.isCommissionFees = this.dataService.isCommissionFees;
    this.isAdHocCommissionable = this.dataService.isAdHocCommissionable;
    this.isDiscountItemEnabled = this.dataService.isDiscountItemEnabled;
    this.isGlobalCategoryEnabled = this.dataService.isGlobalCategoryEnabled;
    this.isMarkAsInventoryEnabled = this.dataService.isMarkAsInventoryEnabled;
    this.isPartWarrantiesEnabled = this.dataService.isPartWarrantiesEnabled;
    this.isOnlineInvOrderEnabled = this.dataService.isOnlineInvOrderEnabled;
    this.isEnhancedTSEnabled = this.dataService.isEnhancedTSEnabled;
    this.isPassThroughTaxEnable = this.dataService.isPassThroughTaxEnable;
    this.isQTQAddOnEnable = this.dataService.isQTQAddOnEnable;
    this.canEditClassifications = this.dataService.canEditClassifications;
    this.isQuickServiceEnabled = this.dataService.isQuickServiceEnabled;
    if(this.isQuickServiceEnabled) {
      this.partsLookupItemList();
    }
  }

  handleClose({ isSuccess, data }) {
    this.dynamicDialogRef.close();
  }

  partsLookupItemList() {
    try {
      this.httpService.getPartsLookupItems().then((res: any[]) => {
        if (!res?.length) return;
        this.partsLookupDropDownList = res.map((res) => ({
          ...res,
          status: true,
          type: 'partLookUp',
          title: res.name,
        }));
        
        this.partsLookupDropDownList = this.partsLookupDropDownList.sort((a, b) => a.title.localeCompare(b.title));
      });
    } catch (err) {
      console.log(err);
    }
  }
}
